import { render, staticRenderFns } from "./personalizado.vue?vue&type=template&id=5ec50ded&scoped=true"
var script = {}
import style0 from "./personalizado.vue?vue&type=style&index=0&id=5ec50ded&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec50ded",
  null
  
)

export default component.exports